import type { ReactElement } from 'react';

// legacy-api appends " - please contact <support email> if you have any concerns, ..." to every
// error text. The reason goes on its own line, above the support line.
const SUPPORT_SUFFIX = /^(.+?)\s+-\s+(please contact .+)$/i;
const EMAIL = /([^\s@]+@[^\s@]+\.[a-z]{2,})/i;

function splitSupportLine(message: string) {
  const match = message.match(SUPPORT_SUFFIX);
  if (!match) return { reason: message };

  return { reason: `${match[1].replace(/[.:]$/, '')}:`, support: match[2] };
}

interface SupportLineProps {
  text: string;
}

function SupportLine({ text }: SupportLineProps): ReactElement {
  // split() with a capture group puts each email at an odd index.
  const parts = text.split(EMAIL);

  return (
    <p className="vtwo:text-auth-muted">
      {parts.map((part, index) => {
        if (index % 2 === 0) return part;

        return (
          <a
            key={index}
            href={`mailto:${part}`}
            className="vtwo:rounded-sm vtwo:underline vtwo:outline-none vtwo:hover:text-auth-foreground vtwo:focus-visible:ring-2 vtwo:focus-visible:ring-auth-focus"
          >
            {part}
          </a>
        );
      })}
    </p>
  );
}

interface AuthErrorProps {
  message: string;
}

function AuthError({ message }: AuthErrorProps): ReactElement {
  const { reason, support } = splitSupportLine(message);

  return (
    <div role="alert" className="vtwo:text-xs vtwo:leading-[normal]">
      <p className="vtwo:text-auth-error">{reason}</p>
      {support && <SupportLine text={support} />}
    </div>
  );
}

export default AuthError;
